import { useNavigate } from "react-router-dom";
import XoiComHeading from "../components/generics/XoiComHeading";

function Error() {
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate("/home");
  };
  return (
    <div className="error-page">
      <XoiComHeading heading="404" />
      <h3>Page not found</h3>
      <button
        className="custom-button-link"
        style={{ color: "var(--bg-red)", "--btn-underline-color": "var(--bg-red)" }}
        onClick={handleGoHome}
      >
        Back to Home
      </button>
    </div>
  );
}

export default Error;
